import ToastMessage from "../toastMessage/ToastMessage";

const passwordCheck = (password, showToast = true) => {
    const SPECIAL_CHARS = /[!@#$%^&*(),.?":{}|<>~^/[\];=+-]/;
    let errorMsg = null;

    if (password.length < 8 || password.length > 16) {
        errorMsg = "A senha deve ter entre 8 e 16 caracteres.";
    } else if (!/[a-z]/.test(password)) {
        errorMsg = "A senha deve conter pelo menos uma letra minúscula.";
    } else if (!/[A-Z]/.test(password)) {
        errorMsg = "A senha deve conter pelo menos uma letra maiúscula.";
    } else if (!/[0-9]/.test(password)) {
        errorMsg = "A senha deve conter pelo menos um número.";
    } else if (!SPECIAL_CHARS.test(password)) {
        errorMsg = "A senha deve conter pelo menos um caractere especial.";
    }

    if (errorMsg && showToast) {
        return ToastMessage({ cod: "e", texto: errorMsg });
    }

    return errorMsg;
}
export default passwordCheck;